/* eslint-disable no-unused-vars */
import { useCallback, useState, useEffect } from 'react';
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  Container,
  Grid,
  Link,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Divider,
  useTheme,
  LinearProgress
} from '@mui/material';
import { customerApi } from '../../api/customerApi';
import { CustomerCommercialActions, CustomerContactDetails, CustomerFormationsList } from '../../components/dashboard/customer';
import useMounted from '../../hooks/useMounted';
import ChevronRightIcon from '../../icons/ChevronRight';
import PencilAltIcon from '../../icons/PencilAlt';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import useSettings from '../../hooks/useSettings';
import * as Yup from 'yup';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import useAuth from '../../hooks/useAuth';
import { relaunchApi } from '../../api/relaunchApi';
import RelaunchCustomerProDetails from '../../components/dashboard/relaunch/RelaunchCustomerProDetails';
import RelaunchCustomerTabRelaunch from '../../components/dashboard/relaunch/RelaunchCustomerTabRelaunch';

const tabs = [
  { label: 'Informations', value: 'informations' },
  { label: 'Formations', value: 'formations' },
  { label: 'Relance', value: 'relance' },
  { label: 'Commercial', value: 'commercial' }
];

const RelaunchCustomerDetails = () => {
  const theme = useTheme();
  const mounted = useMounted();
  const { user } = useAuth();
  const { settings } = useSettings();
  const [customer, setCustomer] = useState(null);
  const [customersCampaignIds, setCustomersCampaignIds] = useState(null);
  const [before, setBefore] = useState(null);
  const [after, setAfter] = useState(null);
  const [isTreated, setIsTreated] = useState(false);
  const [currentTab, setCurrentTab] = useState('informations');
  const [commentRelance, setCommentRelance] = useState({});

  const [initialValues, setInitialValues] = useState({
    civility: '',
    firstname: '',
    maidenName: '',
    lastname: '',
    birthday: '',
    email: '',
    adress: null,
    zip: null,
    city: '',
    department: '',
    region: '',
    profession: '',
    specialite: null,
    modeOfExercise: null,
    phone: '',
    phoneFix: '',
    adeliRpps: '',
    numSecu: '',
    mdpMondpc: '',
    mdpFifpl: '',
    remplacant: false,
    siret: '',
    birthTown: '',
    country: '',
    callTrack: null,
    callTrackRelance: null,
    antecedents: '',
    institution: '',
    groupment: '',
    notCall: '',
    startRelaunchDate: '',
    submit: ''
  });
  const { customerId, endDateRelaunch, state } = useParams();
  const [editing, setEditing] = useState(false);
  const [formations, setFormations] = useState([]);
  const [autoZip, setAutoZip] = useState(null);
  const navigate = useNavigate();

  const searchPlace = async (value) => {
    const urlPlace = `https://geo.api.gouv.fr/communes?codePostal=${value}&fields=nom,departement,region&format=json&geometry=centre`;
    try {
      const res = await fetch(urlPlace);
      return res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

  const update = (values) => {
    const tempCustomer = { ...customer };
    tempCustomer.apprenant.civility = values.civility;
    tempCustomer.apprenant.firstname = values.firstname;
    tempCustomer.apprenant.maiden_name = values.maidenName;
    tempCustomer.apprenant.lastname = values.lastname;
    tempCustomer.apprenant.birthday = values.birthday;
    tempCustomer.apprenant.email = values.email;
    tempCustomer.apprenant.adress = values.adress;
    tempCustomer.apprenant.zip = values.zip;
    tempCustomer.apprenant.city = values.city;
    tempCustomer.apprenant.department = values.department;
    tempCustomer.apprenant.region = values.region;
    tempCustomer.apprenant.profession = values.profession;
    tempCustomer.apprenant.specialite = values.specialite;
    tempCustomer.apprenant.mode_of_exercise = values.modeOfExercise;
    tempCustomer.apprenant.phone = values.phone;
    tempCustomer.apprenant.phone_fix = values.phoneFix;
    tempCustomer.apprenant.adeli_rpps = values.adeliRpps;
    tempCustomer.apprenant.num_secu = values.numSecu;
    tempCustomer.apprenant.mdp_mondpc = values.mdpMondpc;
    tempCustomer.apprenant.call_track = values.callTrack;
    tempCustomer.apprenant.call_track_relance = values.callTrackRelance;
    tempCustomer.apprenant.antecedents = values.antecedents;
    tempCustomer.apprenant.remplacant = values.remplacant;
    tempCustomer.apprenant.mdp_fifpl = values.mdpFifpl;
    tempCustomer.apprenant.siret = values.siret;
    tempCustomer.apprenant.not_call = values.notCall;
    tempCustomer.apprenant.birth_town = values.birthTown;
    tempCustomer.apprenant.country = values.country;
    tempCustomer.apprenant.start_relaunch_date = values.startRelaunchDate;
    setCustomer(tempCustomer);
  };

  const [time, setTime] = useState(0);
  const saveTime = () => {
    // no-op
  };

  const getCustomer = useCallback(async () => {
    try {
      const data = await customerApi.getCustomer(customerId, localStorage.getItem('accessToken'));
      const dataCustomersRelaunch = await relaunchApi.getCustomersRelaunch(endDateRelaunch, state, localStorage.getItem('accessToken'));
      if (data.length === 0) {
        throw new Error('L\'apprenant n\'existe pas');
      }

      if (mounted.current) {
        setCustomer(data);
        setFormations(data.formations_informations);
        setCustomersCampaignIds(dataCustomersRelaunch);

        setInitialValues({
          civility: data.apprenant.civility,
          firstname: data.apprenant.firstname,
          maidenName: data.apprenant.maiden_name,
          lastname: data.apprenant.lastname,
          birthday: data.apprenant.birthday,
          email: data.apprenant.email,
          adress: data.apprenant.adress,
          zip: data.apprenant.zip,
          city: data.apprenant.city,
          department: data.apprenant.department,
          region: data.apprenant.region,
          profession: data.apprenant.profession,
          specialite: data.apprenant.specialite,
          modeOfExercise: data.apprenant.mode_of_exercise,
          phone: data.apprenant.phone,
          phoneFix: data.apprenant.phone_fix,
          adeliRpps: data.apprenant.adeli_rpps,
          numSecu: data.apprenant.num_secu,
          mdpMondpc: data.apprenant.mdp_mondpc,
          callTrack: data.apprenant.call_track,
          callTrackRelance: data.apprenant.call_track_relance,
          notCall: data.apprenant.not_call,
          antecedents: data.apprenant.antecedents,
          birthTown: data.apprenant.birth_town,
          country: data.apprenant.country,
          institution: '',
          groupment: '',
          submit: '',
          mdpFifpl: data.apprenant.mdp_fifpl,
          siret: data.apprenant.siret,
          remplacant: data.apprenant.remplacant,
          startRelaunchDate: data.apprenant.start_relaunch_date
        });
      }
    } catch (err) {
      console.error(err);
      navigate('/404', { replace: true });
    }
  }, [mounted, customerId, endDateRelaunch, state, navigate]);

  useEffect(() => {
    getCustomer();
  }, [getCustomer]);

  useEffect(() => {
    if (customersCampaignIds !== null) {
      if (customersCampaignIds.findIndex((el) => el.id.toString() === customerId) === -1) {
        navigate('/404', { replace: true });
      }
      if (customersCampaignIds[1] !== undefined) {
        setAfter(customersCampaignIds[1].id);
      }
      if (customersCampaignIds.findIndex((el) => el.id.toString() === customerId) !== -1) {
        customersCampaignIds.findIndex((el) => el.id.toString() === customerId) - 1 !== -1 
          ? setBefore(customersCampaignIds[customersCampaignIds.findIndex((el) => el.id.toString() === customerId) - 1].id) 
          : setBefore(customerId);
      }
    }
  }, [customersCampaignIds, customerId, navigate]);

  const handleClickEdit = () => {
    if (editing === false) {
      setEditing(true);
    }
  };

  const stopEditing = () => {
    setEditing(false);
  };

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  const validationSchema = Yup
    .object()
    .shape({
      adress: Yup.string().max(255).nullable(),
      birthday: Yup.string().max(10).nullable(),
      profession: Yup.string().max(255),
      maidenName: Yup.string().max(255).nullable(),
      specialite: Yup.string().max(255).nullable(),
      modeOfExercise: Yup.string().max(255).nullable(),
      adeliRpps: Yup.string().max(11).nullable(),
      numSecu: Yup.string().max(13).nullable(),
      callTrack: Yup.string().max(20).nullable(),
      callTrackRelance: Yup.string().max(20).nullable(),
      mdpMondpc: Yup.string().max(255).nullable(),
      siret: Yup.string().max(14).nullable(),
      birthTown: Yup.string().max(255).nullable(),
      country: Yup.string().max(255).nullable(),
      mdpFifpl: Yup.string().max(255).nullable(),
      remplacant: Yup.boolean(),
      civility: Yup.string().max(8).nullable(),
      lastname: Yup
        .string()
        .max(255)
        .required('Le prénom est requis'),
      firstname: Yup
        .string()
        .max(255)
        .required('Le nom est requis'),
      zip: Yup.string().max(5).min(5).nullable(),
      city: Yup.string().max(255).nullable(),
      email: Yup
        .string()
        .email('Doit être une adresse email')
        .max(255)
        .nullable(),
      phone: Yup.string().max(20, 'Il y a trop de numéros.').nullable()
        .when('phoneFix', {
          is: (phoneFix) => !phoneFix || phoneFix.length === 0,
          then: Yup.string()
            .required('Un des deux champs de téléphone est requis.'),
        }),
      phoneFix: Yup.string().max(20, 'Il y a trop de numéros.').nullable()
        .when('phone', {
          is: (phone) => !phone || phone.length === 0,
          then: Yup.string()
            .required('Un des deux champs de téléphone est requis.'),
        }),
      department: Yup.string().max(255).nullable(),
      region: Yup.string().max(255).nullable(),
      antecedents: Yup.string().nullable(),
      notCall: Yup.string().max(45).nullable(),
      institution: Yup.string().max(10).nullable(),
      groupment: Yup.string().max(10).nullable(),
      startRelaunchDate: Yup.string().max(10).nullable(),
    }, [['phone', 'phoneFix']]);

  if (!customer) {
    return null;
  }

  return (
    <>
      {user.id_service === 4 && (
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              if (values.zip !== null && autoZip) {
                await searchPlace(values.zip).then((value) => {
                  if (value.length > 0) {
                    if (typeof value[0].nom !== 'undefined' && typeof value[0].departement !== 'undefined' && typeof value[0].region !== 'undefined') {
                      values.city = value[0].nom;
                      values.department = value[0].departement.nom;
                      values.region = value[0].region.nom;
                    }
                  }
                });
              }
              await customerApi.updateCustomer(customerId, values, localStorage.getItem('accessToken'));
              setStatus({ success: true });
              setSubmitting(false);
              setEditing(false);
              toast.success('Apprenant mis à jour !');
              update(values);
              setAutoZip(false);
            } catch (err) {
              console.error(err);
              toast.error('Il y a eu un souci lors de la mise à jour !');
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Helmet>
                <title>Tableau de bord: Apprenant | Syndays</title>
              </Helmet>
              <Box
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : '#0b0f19',
                  minHeight: '100%',
                  py: 4,
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {/* Glowing background spots */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: -100,
                    left: -100,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, rgba(59, 130, 246, 0) 70%)',
                    pointerEvents: 'none',
                    zIndex: 0
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    top: 200,
                    right: -100,
                    width: 500,
                    height: 500,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0) 70%)',
                    pointerEvents: 'none',
                    zIndex: 0
                  }}
                />

                <Container maxWidth={settings.compact ? 'xl' : false} sx={{ position: 'relative', zIndex: 1 }}>
                  <Grid
                    container
                    justifyContent="space-between"
                    spacing={3}
                    sx={{ mb: 4 }}
                  >
                    <Grid item>
                      <Typography
                        color="text.primary"
                        variant="h4"
                        sx={{ fontWeight: 800, letterSpacing: '-0.025em' }}
                      >
                        {customer.apprenant.firstname} {customer.apprenant.lastname}
                      </Typography>
                      <Breadcrumbs
                        aria-label="breadcrumb"
                        separator={<ChevronRightIcon fontSize="small" />}
                        sx={{ mt: 1.5 }}
                      >
                        <Link
                          color="text.primary"
                          component={RouterLink}
                          to="/dashboard"
                          variant="subtitle2"
                          underline="hover"
                        >
                          Tableau de bord
                        </Link>
                        <Link
                          color="text.primary"
                          component={RouterLink}
                          to="/dashboard/relaunch"
                          variant="subtitle2"
                          underline="hover"
                        >
                          Relance
                        </Link>
                        <Typography
                          color="text.secondary"
                          variant="subtitle2"
                        >
                          Apprenant
                        </Typography>
                      </Breadcrumbs>
                      {customersCampaignIds !== null && customersCampaignIds !== undefined && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mt: 2.5 }}>
                          <IconButton
                            color="primary"
                            sx={{ 
                              bgcolor: !isTreated || customerId === customersCampaignIds[customersCampaignIds.length - 1].id.toString() 
                                ? 'action.hover' 
                                : 'primary.main',
                              color: !isTreated || customerId === customersCampaignIds[customersCampaignIds.length - 1].id.toString() 
                                ? 'text.disabled' 
                                : '#ffffff',
                              borderRadius: '12px',
                              width: 40,
                              height: 40,
                              boxShadow: isTreated && customerId !== customersCampaignIds[customersCampaignIds.length - 1].id.toString()
                                ? '0 4px 12px rgba(59, 130, 246, 0.25)'
                                : 'none',
                              '&:hover': {
                                bgcolor: !isTreated || customerId === customersCampaignIds[customersCampaignIds.length - 1].id.toString() 
                                  ? 'action.hover' 
                                  : 'primary.dark'
                              }
                            }}
                            onClick={() => window.location.href = `https://${tenant}.syndays.fr/dashboard/relaunch/${state}/${endDateRelaunch}/customer/${after}`}
                            disabled={!isTreated || customerId === customersCampaignIds[customersCampaignIds.length - 1].id.toString()}
                          >
                            <ChevronRightIcon fontSize="medium" />
                          </IconButton>
                          
                          <Box sx={{ width: 140, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                            <LinearProgress 
                              variant="determinate" 
                              value={((customersCampaignIds.findIndex((el) => el.id === parseInt(customerId, 10)) + 1) / customersCampaignIds.length) * 100}
                              sx={{
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: theme.palette.mode === 'light' ? '#e2e8f0' : 'rgba(255,255,255,0.05)',
                                '& .MuiLinearProgress-bar': {
                                  borderRadius: 3,
                                  background: 'linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%)'
                                }
                              }}
                            />
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', fontSize: '0.72rem' }}>
                              {`Client ${customersCampaignIds.findIndex((el) => el.id === parseInt(customerId, 10)) + 1} sur ${customersCampaignIds.length}`}
                            </Typography>
                          </Box>

                          {customersCampaignIds.length === 1 && isTreated && (
                            <Button
                              color="primary"
                              onClick={() => navigate(`/dashboard/relaunch/${state}/${endDateRelaunch}`, { replace: true })}
                              variant="contained"
                              sx={{
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 2.5
                              }}
                            >
                              Finir campagne
                            </Button>
                          )}
                        </Box>
                      )}
                    </Grid>
                    <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ m: -1 }}>
                        {editing ? (
                          <>
                            <Button
                              color="error"
                              startIcon={<CancelIcon fontSize="small" />}
                              onClick={stopEditing}
                              sx={{ m: 1, borderRadius: '12px', textTransform: 'none', fontWeight: 700, px: 2.5 }}
                              variant="outlined"
                            >
                              Annuler
                            </Button>
                            <Button
                              color="primary"
                              startIcon={<SendIcon fontSize="small" />}
                              sx={{ 
                                m: 1, 
                                borderRadius: '12px', 
                                textTransform: 'none', 
                                fontWeight: 700, 
                                px: 2.5,
                                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
                              }}
                              disabled={isSubmitting}
                              type="submit"
                              variant="contained"
                            >
                              Enregistrer
                            </Button>
                          </>
                        ) : (
                          <Button
                            color="primary"
                            startIcon={<PencilAltIcon fontSize="small" />}
                            sx={{ 
                              m: 1, 
                              borderRadius: '12px', 
                              textTransform: 'none', 
                              fontWeight: 700, 
                              px: 2.5,
                              background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
                            }}
                            onClick={handleClickEdit}
                            variant="contained"
                          >
                            Modifier
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  <Box sx={{ mt: 2 }}>
                    <Tabs
                      indicatorColor="primary"
                      onChange={handleTabsChange}
                      scrollButtons="auto"
                      textColor="primary"
                      value={currentTab}
                      variant="scrollable"
                      sx={{
                        backgroundColor: theme.palette.mode === 'light' ? 'rgba(241, 245, 249, 0.8)' : 'rgba(30, 41, 59, 0.5)',
                        backdropFilter: 'blur(8px)',
                        borderRadius: '16px',
                        p: 0.5,
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.05)',
                        minHeight: 'auto',
                        mb: 3,
                        '& .MuiTabs-indicator': {
                          height: '100%',
                          borderRadius: '12px',
                          backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'rgba(255, 255, 255, 0.08)',
                          boxShadow: theme.palette.mode === 'light' ? '0 4px 12px rgba(0, 0, 0, 0.05)' : 'none',
                          border: theme.palette.mode === 'light' ? 'none' : '1px solid rgba(255, 255, 255, 0.1)',
                        },
                        '& .MuiTab-root': {
                          fontWeight: 700,
                          fontSize: '0.85rem',
                          textTransform: 'none',
                          minWidth: 100,
                          minHeight: 40,
                          py: 1,
                          px: 2.5,
                          borderRadius: '12px',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          zIndex: 1,
                          color: 'text.secondary',
                          '&.Mui-selected': {
                            color: 'primary.main',
                          },
                          '&:hover': {
                            color: 'primary.main',
                            opacity: 0.9,
                            transform: 'translateY(-1px)'
                          }
                        }
                      }}
                    >
                      {tabs.map((tab) => (
                        <Tab key={tab.value} label={tab.label} value={tab.value} />
                      ))}
                    </Tabs>
                  </Box>

                  <Box sx={{ mt: 3 }}>
                    {currentTab === 'informations' && (
                      <Grid container spacing={3}>
                        <Grid item lg={settings.compact ? 6 : 4} md={6} xl={settings.compact ? 6 : 3} xs={12}>
                          <CustomerContactDetails
                            adress={customer.apprenant.adress}
                            birthday={customer.apprenant.birthday}
                            city={customer.apprenant.city}
                            email={customer.apprenant.email}
                            isVerified={customer.apprenant.isVerified}
                            phone={customer.apprenant.phone}
                            phoneFix={customer.apprenant.phone_fix}
                            region={customer.apprenant.region}
                            civility={customer.apprenant.civility}
                            firstname={customer.apprenant.firstname}
                            maidenName={customer.apprenant.maiden_name}
                            lastname={customer.apprenant.lastname}
                            zip={customer.apprenant.zip}
                            department={customer.apprenant.department}
                            notCall={customer.apprenant.not_call}
                            birthTown={customer.apprenant.birth_town}
                            country={customer.apprenant.country}
                            autoZip={autoZip}
                            setAutoZip={setAutoZip}
                            editing={editing}
                            errors={errors}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            touched={touched}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </Grid>
                        <Grid item lg={settings.compact ? 6 : 4} md={6} xl={settings.compact ? 6 : 3} xs={12}>
                          <RelaunchCustomerProDetails
                            profession={customer.apprenant.profession}
                            modeOfExercise={customer.apprenant.mode_of_exercise}
                            adeliRpps={customer.apprenant.adeli_rpps}
                            numSecu={customer.apprenant.num_secu}
                            mdpMondpc={customer.apprenant.mdp_mondpc}
                            comment_commercial={customer.last_commercial_comment}
                            comment_relance={customer.last_relance_comment}
                            antecedents={customer.apprenant.antecedents}
                            specialite={customer.apprenant.specialite}
                            callTrack={customer.apprenant.call_track}
                            callTrackRelance={customer.apprenant.call_track_relance}
                            callTrackRelanceList={customer.call_track_relance}
                            notCall={customer.apprenant.not_call}
                            startRelaunchDate={customer.apprenant.start_relaunch_date}
                            editing={editing}
                            errors={errors}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            touched={touched}
                            values={values}
                            setFieldValue={setFieldValue}
                            customer={customer}
                            formations={formations}
                            customerId={customerId}
                            setIsTreated={setIsTreated}
                            saveTime={saveTime}
                            commentRelance={commentRelance}
                            setCommentRelance={setCommentRelance}
                            siret={customer.apprenant.siret}
                            mdpFifpl={customer.apprenant.mdp_fifpl}
                            remplacant={customer.apprenant.remplacant}
                          />
                        </Grid>
                      </Grid>
                    )}
                    {currentTab === 'formations' && (
                      <CustomerFormationsList
                        formations={customer.formations}
                        apprenant={customer.apprenant}
                        orientations={customer.orientations}
                        formationsDec={customer.formationsDec}
                        sources={customer.sources}
                        user={user}
                      />
                    )}
                    {currentTab === 'relance' && (
                      <RelaunchCustomerTabRelaunch
                        customerId={customerId}
                        user={user}
                        setIsTreated={setIsTreated}
                        setCommentRelance={setCommentRelance}
                      />
                    )}
                    {currentTab === 'commercial' && (
                      <CustomerCommercialActions
                        customerId={customerId}
                        user={user}
                        customer={customer}
                        formations={formations}
                      />
                    )}
                  </Box>
                </Container>
              </Box>
            </form>
          )}
        </Formik>
      )}
      {user.id_service !== 4 && (
        <Container maxWidth="md" sx={{ py: 8 }}>
          <Card sx={{ p: 4, textAlign: 'center', borderRadius: '24px', boxShadow: '0 8px 32px rgba(0,0,0,0.05)' }}>
            <Typography color="error" variant="h6" sx={{ fontWeight: 700 }}>
              Vous n&apos;avez pas les autorisations nécessaires pour accéder à cette page.
            </Typography>
          </Card>
        </Container>
      )}
    </>
  );
};

export default RelaunchCustomerDetails;
